import _ from 'lodash/fp';
import GraniteError from 'granite-admin/utils/granite-error';
class Organisation {
  constructor({
    pk,
    name,
    phone,
    country_code,
    ...data
  }) {
    if (_.isNil(pk) || _.isNil(name) || !_.isString(name)) {
      throw new GraniteError('Organization must have name and pk');
    }
    this.pk = pk;
    this.name = name;
    this.industry = data.industry;
    this.label = name;
    this.value = pk;
    this.email = data.email;
    this.phone = phone?.length > 0 ? {
      dialCode: phone?.split(' ')[0].replace('+', ''),
      number: phone.replace(/\s/g, '').replace(`+`, '').replace('-', ''),
      countryCode: country_code?.toLowerCase(),
      phone: phone
    } : {
      dialCode: '',
      number: '',
      countryCode: country_code
    };
    this.phone_ext = data.phone_ext;
    this.billingPlan = data.business_plan;
    this.address = data?.extra_data?.address ?? '';
    this.location = data.location || {};
    this.logo = data.logo;
    this.created_at = data.created_at;
    this.extraData = data.extra_data;
    this.domain = data.domain;
    this.firstName = data?.user?.first_name ?? '';
    this.lastName = data?.user?.last_name ?? '';
  }
}
export default Organisation;